import React, {useEffect} from "react";
import {CustomCloseModalIcon} from "../../components/ui-base/icons/custom-close-modal-icon";
import {Grid} from "@mui/material";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {Chart, Legend, PieSeries, Title, Tooltip} from "@devexpress/dx-react-chart-material-ui";
import {Animation, EventTracker} from "@devexpress/dx-react-chart";
import {CategoryModel} from "../../models/category.model";
import {useTranslation} from "react-i18next";

export const ChartModal: React.FC<{open: boolean, setOpen: Function, categories: CategoryModel[]}> = ({open, setOpen, categories}) => {
    const [chartData, setChartData] = React.useState<any>([]);
    const { t } = useTranslation(['publisher', 'common']);

    useEffect(() => {
        const tmpData = [];

        categories.forEach((category) => {
            tmpData.push({
                title: category.name,
                val: category.count
            });
        });
        setChartData(tmpData);
    }, [categories]);

    return (
        <>
            {open &&
            <StyledBlockedContent container direction={"column"} justifyContent={"center"} alignContent={"center"}>
                <StyledBlockedInfo item container direction={"column"} alignItems={"center"} spacing={2}>
                    <StyledCloseButton onClick={() => {
                        setOpen(false);
                    }}><CustomCloseModalIcon/></StyledCloseButton>

                    <Grid item>
                        <StyledBlockedTitle>{t('createPublisherProfile.chartTitle')}</StyledBlockedTitle>
                    </Grid>

                    <Grid item style={{width: '100%', maxWidth: '600px', margin: '0 auto'}}>
                        {chartData?.length > 0 &&
                        <Chart
                            data={chartData}
                        >
                            <PieSeries
                                valueField="val"
                                argumentField="title"
                                innerRadius={0.6}
                            />
                            <Title
                                text=""
                            />
                            <EventTracker />
                            <Legend position="bottom"/>
                            <Tooltip contentComponent={(obj) => (<div>{obj.text}%</div>)}/>
                        </Chart>
                        }
                    </Grid>
                </StyledBlockedInfo>
            </StyledBlockedContent>
            }
        </>
    )

}

const StyledBlockedContent = styled(Grid)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.8561799719887955);
  z-index: 1111111;
`;

const StyledBlockedInfo = styled(Grid)`
  background: #FBF5FF;
  border: 1px solid ${Colors.lightViolet};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  max-width: 800px !important;
  position: relative;
`;

const StyledBlockedImgContainer = styled(Grid)`
  margin-top: -55px;
`;

const StyledBlockedTitle = styled('h6')`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${Colors.lightViolet};
  text-align: center;
`;

const StyledBlockedDescription = styled('h6')`
  font-size: 0.9rem;
  font-weight: 500;
  color: ${Colors.lightViolet};
  text-align: center;
`;

const StyledCloseButton = styled('div')`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;
